<template>
  <span @click="click()" style="border-radius: 12px; display: inline-block; width: 65px; height: 26px; border: 2px solid #309FFF;">
    <span
      :class="status ? 'bg-primary' : 'bg-secondary'"
      class="margin-trans font-button"
      :style="{ marginLeft: status ? '36px' : '1px' }"
      style="border-radius: 12px; display: inline-block; width: 24px; height: 20px; margin-top: 1px; margin-bottom: 1px;"
    ></span>
  </span>
</template>

<script>
export default {

  name: 'Toggle',

  props: {
    click: Function,
    status: Boolean
  }

}
</script>

<style scoped>
.margin-trans {
  transition: margin .4s, background-color .4s;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Toggle.vue